__turbopack_context__.v({
  "buttonWrp": "quoteForm-module-scss-module__Zj0lLW__buttonWrp",
  "checkbox": "quoteForm-module-scss-module__Zj0lLW__checkbox",
  "currencyWrp": "quoteForm-module-scss-module__Zj0lLW__currencyWrp",
  "estimatedDuration": "quoteForm-module-scss-module__Zj0lLW__estimatedDuration",
  "estimatedSizeWrp": "quoteForm-module-scss-module__Zj0lLW__estimatedSizeWrp",
  "firstRow": "quoteForm-module-scss-module__Zj0lLW__firstRow",
  "form": "quoteForm-module-scss-module__Zj0lLW__form",
  "generateQuoteButton": "quoteForm-module-scss-module__Zj0lLW__generateQuoteButton",
  "input": "quoteForm-module-scss-module__Zj0lLW__input",
  "recaptchaWrp": "quoteForm-module-scss-module__Zj0lLW__recaptchaWrp",
  "row": "quoteForm-module-scss-module__Zj0lLW__row",
});
